import React, { Component } from 'react'; 
import pdficon from './icon_pdf.png';
import { Table } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { Alert, Button, ProgressBar, Modal } from 'react-bootstrap';
import Iframe from 'react-iframe'
import { withTranslation } from 'react-i18next'
import Customize from './Customize'
import { io } from 'socket.io-client';
import { Cookies } from 'react-cookie';

import axios from 'axios';
const constants = require('./constants');
const cookies = new Cookies();

const MAX_SIGN_RETRY_COUNT = 3;

class Pending extends Component {
    constructor(props) {
        super(props) //since we are extending class Table so we have to use super in order to override Component class constructor
 
        this.state = {
            myPendingDocs:[],
            pendingDocs:[],
            selected: [],
            authMethodModalModes: [],
            showAlert: false,
            operationOngoing: false,
            authenticationURL: null,
            signerAuthReady:false,
            showAuthMethodModal:false,
            showRejectConfirmModal:false,
            signOngoingIndex:-1,
            signDocumentOngoingIndexUpdate: false,
            myEmailAddress: null
        }
        this.parentEventSend = props.parentEventCb;
        this.mounted = false;
        this.signDocumentOngoingIndex = 1;
        this.suomiAuth = undefined;
    }

   
    checkFetchRespSession = (resp)=> {
        if (!resp.ok) {
          if(resp.status === 401) {
            this.parentEventSend("SESSION_EXPIRED");
          }
          throw Error(resp.statusText);
        }
        return resp;
    } 

    checkAxiosRespSession = (err)=> {
        if(err.response && err.response.status === 401) {
          this.parentEventSend("SESSION_EXPIRED");
          return true;
      }
      return false;
    }

    getMyCategoryData = (request, myEmailAddress) => {
        var mySignData = request.signers.filter(signer => signer.email === myEmailAddress)
        if(mySignData.length === 1 ) {
            if(mySignData[0].category !== null && mySignData[0].order_num != null) {
                return {category:mySignData[0].category, orderNum:mySignData[0].order_num};
            } else {// old request without sign category -> can sign
                return null;
            }
        }
        return null; // should never happen, but allow signing
    }

    setCanSign = (resp, myEmailAddress) => {
        var myCategory;

        return resp.map (signRequest => {
            myCategory = this.getMyCategoryData(signRequest, myEmailAddress);
            if(myCategory === null) {
                // old request -> can sign
                signRequest.canSign = true;
            } else if(signRequest.sign_category === myCategory.category) {
                if(signRequest.sign_category_force_order) {
                    if(signRequest.sign_category_order_num === myCategory.orderNum) {
                        signRequest.canSign = true;    // my turn to sign
                    } else {
                        signRequest.canSign = false;        
                    }
                } else { // force order not set -> my turn to sign
                    signRequest.canSign = true;    
                }
            } else {
                signRequest.canSign = false;
            }
            return signRequest;
        });
    }

    refreshLists = (failedDocs)=> {
        fetch(constants.SERVER_URL+"/api/mypendingdocs",{method:'get'})
        .then(resp => this.checkFetchRespSession(resp))
        .then(resp =>resp.json())
        .then(resp => this.combineSignedCounts(resp))
        .then(resp => this.combineStatusAndTimestamp(resp))
        .then(resp => this.setCanSign(resp, this.state.myEmailAddress))
        .then(data => {
            if(failedDocs.length > 0) { // partially failed -> mark failed docs
                var failMarkedData = data.map(item => {
                    var failedTbl = failedDocs.filter(failedDoc => failedDoc.reqId === item.id)
                    if(failedTbl.length === 1) {
                        // this is failed doc
                        item.signFailed = true;
                    }
                    return item;
                })
                this.setState({myPendingDocs:failMarkedData});
                this.setState({showAlert:true});
                this.setState({selected:failedDocs.map(item =>item.reqId)}) // Clear selected array. Leave only failed.
            } else { // All Ok -> refresh list
                this.setState({myPendingDocs:data});
                this.setState({selected:[]}); // Clear selected array
            }
        })
        .catch(error => {
            console.log("Fetching mypendingdocs error:", error);
        });

        fetch(constants.SERVER_URL+"/api/pendingdocs",{method:'get'})
        .then(resp => this.checkFetchRespSession(resp))
        .then(resp =>resp.json())
        .then(resp => this.combineSignedCounts(resp))
        .then(resp => this.combineStatusAndTimestamp(resp))
        .then(data =>this.setState({pendingDocs:data}))
        .catch(error => console.log("Fetching pendingDocs error:", error));
    }

    getAuthsData = (selectedDocs) => {
        var methods = []; 
        var allSupportedMethods = ["AUTH_METHOD_CALLSIGN", "AUTH_METHOD_BANK", "AUTH_METHOD_MOBILE", "AUTH_METHOD_SUOMIFI"];
        var docsToSign = this.getDocsToSign();
        var auths = docsToSign.map((item) =>  {
            return {authMethods:item.authMethods, suomiAuth:item.suomiAuth} 
        });

        var suomiAuth = undefined;

        for(var i=0;i<allSupportedMethods.length;i++) {
            for(var s=0;s<auths.length;s++) {
                if(auths[s].authMethods === null || auths[s].authMethods === '') {
                    // all methods supported (suomi.fi excluded)
                    methods.push("AUTH_METHOD_CALLSIGN");
                    methods.push("AUTH_METHOD_BANK");
                    methods.push("AUTH_METHOD_MOBILE");
                } else if(auths[s].authMethods.includes(allSupportedMethods[i])) {
                    if(!methods.includes(allSupportedMethods[i])) {
                        methods.push(allSupportedMethods[i]);
                        if(allSupportedMethods[i] === "AUTH_METHOD_SUOMIFI" && !suomiAuth) {
                            // console.log("LISÄTÄÄN SUOMI AUTH", auths[s])
                            suomiAuth = auths[s].suomiAuth;
                        }
                    }
                }
            }
        }
        if(!suomiAuth) {
            // Can not find from selected requests -> check user's suomiAuth from cookies
            // console.log("LISÄTÄÄN SUOMI.FI KÄYTTÄJÄN ASETUKSISTA");
            suomiAuth = cookies.get("suomiAuth");
            if(suomiAuth) {
                methods.push("AUTH_METHOD_SUOMIFI");
            }
        }
        return {methods:methods, suomiAuth:suomiAuth};
    }

    startSignProcess = () => {
        if(this.state.operationOngoing === false && this.state.selected.length > 0) {
            this.setState({operationOngoing:true})
            this.signDocumentOngoingIndex = 1;
            // check if there is only one auth method allowed -> use it -> do not show modal
            var auths = this.getAuthsData(this.state.selected);
            var authMethods = auths.methods;
            this.suomiAuth = auths.suomiAuth;
            console.log("AUTH METHODS", authMethods)
            console.log("SUOMI AUTH", this.suomiAuth)
            if(authMethods.length === 1 || 
                (authMethods.length === 2 && authMethods.includes("AUTH_METHOD_BANK") && authMethods.includes("AUTH_METHOD_MOBILE")) // These methods are handled via same Button in AuthMode query at the moment
                ) {
                this.authenticateSigner(authMethods.toString());
            } else {
                // Show authentication method modal
                this.setState({authMethodModalModes:authMethods});
                this.setState({showAuthMethodModal:true});
            }
        }
    }

    authenticateSigner = (authMethods) => {
            sessionStorage.setItem('docsToSign', JSON.stringify(this.state.selected));

            var authReq = {
                authMethod:authMethods
            }
            if(this.suomiAuth) {
                authReq.suomiAuth = this.suomiAuth;
            }
            axios.post(constants.SERVER_URL+'/api/authsigner', authReq)
            .then(resp => {
                console.log("/api/authsigner data:", resp.data);
                if(resp.data.redirect) {
                    window.location.href = ""+resp.data.redirect+"";//<<== autentikointi koko näytöllä
    //                this.setState({authenticationURL:resp.data.redirect}) //<<== autentikointi iframessa
                sessionStorage.setItem("targetPage", constants.SERVER_CONTEXT_PATH+"/pending");
                }
            })            
            .catch((err) => {
                if(!this.checkAxiosRespSession(err)) {
                    console.log("/api/authsigner error:", err);
                    sessionStorage.removeItem('docsToSign');
                    this.setState({showAlert:true});
                    this.setState({operationOngoing:false});
                }
            })
    }

    getDocsToSign = () => {
        var docsToSign = this.state.selected.map((selected) => {
            var docs = this.state.myPendingDocs.filter((req) => {
             return req.id === selected
            })
            if(docs && docs[0]) {
                return ({
                    reqId:docs[0].id,
                    fileName: docs[0].fileName,
                    origDocId:docs[0].origDocId,
                    signDocId:docs[0].signDocId,
                    authMethods: docs[0].auth_methods,
                    suomiAuth: docs[0].suomi_auth?docs[0].suomi_auth:undefined
                });
            } else {
                return {};
            }
        })
        return docsToSign;
    }

    signSelectedDocuments = async() => {
            this.setState({operationOngoing:true});
            this.setState({signOngoingIndex:1});
            
            var docsToSign = this.getDocsToSign();
           // console.log(JSON.stringify(docsToSign))
           // backend käsittelee aina yhden dokumentin kerrallaan, jonka jälkeen lähettää
           // fronttiin vastauksen. Jokaiselle dokumentille on erikseen kutsuttava backendiä.
           var docsToSignCount = docsToSign.length;
           console.log("Valittujen dokumenttien määrä: ", docsToSignCount);
           var lastItem = false;
           var signResp;

           var socketUrl = "";
           var socketPath = "/api/socket.io/";
           var socket = io(socketUrl, { path:socketPath });
           socket.on("connect", async () => {
             //  console.log("SOCKET:", socket.id);
               for(var retry = 0;retry < MAX_SIGN_RETRY_COUNT && docsToSignCount>0;retry++) {
                console.log("Uudelleen yrityksiä: ", retry);
                 for(var i = 0;i<docsToSignCount;i++) {
                     try {
                         if(retry === MAX_SIGN_RETRY_COUNT-1 && i === docsToSignCount-1) {
                             lastItem = true;
                           //  console.log("LAST ITEM ONGOING");
                         }
                         //console.log("SOCKET ID LÄHETETÄÄN:",socket.id)
                         this.signDocumentOngoingIndex = 1;
                         this.setState({signDocumentOngoingIndexUpdate:!this.state.signDocumentOngoingIndexUpdate});
                         signResp = await axios.post(constants.SERVER_URL+'/api/signdocuments', {docsToSign:docsToSign, ready:lastItem, socketId: socket.id});
                         if(signResp.status === 206) {
                             // yhtäaikainen allekirjoitus
                             console.log("ASIAKIRJAN YHTÄAIKAINEN ALLEKIRJOITUS -> ESTETTY");
                             // Jos on epäonnistunut, niin laita ensimmäiseksi listalla backend käsittelee aina viimeistä
                             docsToSign.unshift(docsToSign.pop());
                             if(retry === MAX_SIGN_RETRY_COUNT-1) { // viimeinen yritys epäonnistuneille -> päivitetään laskuria
                                 this.setState({signOngoingIndex:this.state.signOngoingIndex+1});
                             }                            
                         } else {
                             // Poista docsToSign listalta onnistunut allekirjoitus(viimeinen listalla)
                             console.log("Allekirjoitus onnistui");
                             docsToSign.pop();
                             this.setState({signOngoingIndex:this.state.signOngoingIndex+1});
                         }
                     }
                     catch(error) {
                         console.log("Allekirjoitus epäonnistui");
                         console.log("signSelectedDocuments", error);
                         if(!this.checkAxiosRespSession(error)) {
                             // Jos on epäonnistunut, niin laita ensimmäiseksi listalla backend käsittelee aina viimeistä
                             docsToSign.unshift(docsToSign.pop());
                             if(retry === MAX_SIGN_RETRY_COUNT-1) {  // viimeinen yritys epäonnistuneille -> päivitetään laskuria
                                 this.setState({signOngoingIndex:this.state.signOngoingIndex+1});
                             } 
                         }
                     };
                 }
                 docsToSignCount = docsToSign.length;
            }
 
             console.log("Epäonnistuneet allekirjoitukset: ", docsToSign);
             // Refresh list data and mark failed docs
             if(docsToSign.length > 0) {
                 this.setState({showAlert:true}); // kaikkia dokumentteja ei voitu allekirjoittaa
             }
             this.refreshLists(docsToSign); // kaikki jotka on jääneet listalle ovat epäonnistuneet
             this.setState({operationOngoing:false});
             this.setState({signOngoingIndex:-1});
             this.parentEventSend("UPDATE_MENU");

             socket.close();
             });

             socket.on("disconnect", (reason) => {
               console.log("Disconnect: ", reason); 
             });

             socket.on("SIGNREQSTATUS", (signedIndex) => {
               //console.log("Signing document index:", signedIndex);
               this.signDocumentOngoingIndex = signedIndex+2;
               this.setState({signDocumentOngoingIndexUpdate:!this.state.signDocumentOngoingIndexUpdate});
             });



     }

     startRejectProcess = () => {
        if(this.state.operationOngoing === false && this.state.selected.length > 0) {
            this.setState({showRejectConfirmModal:true});
        }
    }

    rejectSelectedDocuments = () => {
       // console.log("rejectSelectedDocuments", this.state.selected)
        if(this.state.operationOngoing === false  && this.state.selected.length > 0) {
            this.setState({operationOngoing:true})
            this.setState({showRejectConfirmModal:false});
            var docsToReject = this.state.selected.map((selected) => {
                var docs = this.state.myPendingDocs.filter((req) => {
                return req.id === selected
                })
                return ({
                    reqId:docs[0].id,
                });
            })
            
           // console.log(JSON.stringify(docsToReject))
            axios.post(constants.SERVER_URL+'/api/rejectdocuments', docsToReject) 
            .then(rejectResp => {
               // console.log(rejectResp.status)
                // Refresh list data and mark failed docs
                this.refreshLists(rejectResp.data);
                this.setState({operationOngoing:false});
                this.parentEventSend("UPDATE_MENU");
            })
            .catch(error => {
                if(!this.checkAxiosRespSession(error)) {
                    console.log("rejectSelectedDocuments error:", error);
                    this.setState({showAlert:true});
                    this.setState({operationOngoing:false});
                }
            });
        }               
    }

      handleOnSelect = (row, isSelect) => {
        if (isSelect) {
          this.setState(() => ({
            selected: [...this.state.selected, row.id]
          }));
        } else {
          this.setState(() => ({
            selected: this.state.selected.filter(x => x !== row.id)
          }));
        }
      }
    
      handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r.id);
        if (isSelect) {
          this.setState(() => ({
            selected: ids
          }));
        } else {
          this.setState(() => ({
            selected: []
          }));
        }
      }

      base64ToBinary = (str) =>
      {
          var buf = Buffer.from(str, 'base64');
          return buf.toString('binary');
      }

    getDocument = (id) => {
        return constants.GET_FILE_URL+"/api/getdocbyid/"+id;
    }

    renderCategoryDueDate(category_due_dt) {
        const {t} = this.props;

        if(category_due_dt) {
            var categoryDueDate = this.renderDateTime(category_due_dt).split(" ")[0];

            if(category_due_dt !== null) {
                return (
                    <div className="signersCategoryName">{t("Due date for signature") +" "} <span>{categoryDueDate} </span></div> 
                    );
            } else {
                return null;
            }
        }
        return null;


    }

    renderSigners(propsIn) {
        const {t} = this.props;
        var previousCategory = -1;

        var props = [...propsIn];
        var categoriesStatus = [];

        console.log("renderSigners SIGNER:", props)

        // add categories to list
        for(var i=0;i<props.length;i++) {
            if(props[i].category !== previousCategory) {
                props.splice(i, 0, {id:"CATEGORY", category:props[i].category, force_order:props[i].force_order, category_due_dt:props[i].category_due_dt});
                previousCategory = props[i].category;
                categoriesStatus[props[i].category] = {handledCount:0, signersCount:0};
            } else {
                props[i].id = "SIGNER";
                if(props[i].status === "SIGNED" || props[i].status === "REJECTED") {
                    categoriesStatus[props[i].category].handledCount++;
                }
                categoriesStatus[props[i].category].signersCount++;
            }
        }

        return props.map((signer, index) => {
            const { name, statusText, category, force_order, order_num, id, category_due_dt } = signer //destructuring

            if(id === "CATEGORY") {
                return (
                    <tr key={index}>
                        <td className="signersCategoryNameTd">
                           <div className="signersCategoryName">{t("Taso")} {category+1}</div> 
                           {this.renderCategoryDueDate(category_due_dt)}
                           {force_order?<div>{t("Pakotettu allekirjoitusjärjestys")}</div>:null}
                        </td>
                        
                        <td className="signersCategoryStatus"> {categoriesStatus[category].handledCount + '/' + categoriesStatus[category].signersCount + " " + t("Processed") + " "}</td>
                    </tr>                    
                )
            } else {
                return (
                <tr key={index}>
                    <td className="signersName">{force_order ===true?order_num+1+".":null} {name}</td>
                    <td className="signersStatus">{statusText}</td>
                </tr>
                );
            }
        });
    } 

    renderAttachments(props) {
        return props.map((attachment, index) => {
            const { filename, udid } = attachment //destructuring
            
            return (
                <span key={udid}>
                        <img src={pdficon} alt="Fujitsu" height="20"></img><a href = {this.getDocument(attachment.udid)} download={filename} target="_blank" rel="noopener noreferrer">{filename}</a><br />
                </span>
            )
        });
    } 

    renderDateTime(props) {
        const { t } = this.props;
        return(
            new Intl.DateTimeFormat('fi', 
                                    {
                                        year: 'numeric', 
                                        month: 'numeric', 
                                        day: 'numeric', 
                                        hour: 'numeric', 
                                        minute: 'numeric', 
                                        second: 'numeric', 
                                        timeZoneName: 'short',
                                        hour12: false

                                    }).format(new Date(props)).replace("klo", t("TimeStampReplaceText"))
        )

    }

    renderDate(props) {
        const { t } = this.props;
        return(
            new Intl.DateTimeFormat('fi', 
                                    {
                                        year: 'numeric', 
                                        month: 'numeric', 
                                        day: 'numeric' 
                                    }).format(new Date(props)).replace("klo", t("TimeStampReplaceText"))
        )
    }

    combineSignedCounts(resp) {
        return resp.map((item) => {
            item.signStatus = JSON.stringify({totalCount:item.totalCount,signedCount:item.signedCount, deniedCount:item.deniedCount});
            return item;
         })
    }

    combineStatusAndTimestamp(resp) {
        const { t } = this.props
        return resp.map((item) =>{
            item.signers.map((data) => {
                var status = data.status
                if(status === 'SIGNED' || status === 'REJECTED'){
                    var date = this.renderDateTime(data.decision_date)
                    if(status === 'SIGNED') {
                        data.statusText = t("Signed") + ' (' + date + ' )' }
                    else {
                        data.statusText = t("Rejected") + ' (' + date + ' )' }
                    }
                else {
                    data.statusText = t("Pending") 
                }
                return data
            })
            return item 
        })
    }


    createSignedCountsText(item) {
        const { t } = this.props;

        item = JSON.parse(item);
        var total = item.totalCount;
        var signed = item.signedCount == null ? 0 :item.signedCount;
        var denied = item.deniedCount == null ? 0 :item.deniedCount;
        var signStatus = t("Ongoing") + " " + (signed+denied) + '/' + total + " " + t("Processed") + " ";
        return signStatus;
    }

    checkMounted(resp) {
        if(this.mounted) {
            return resp;
        } else {
            throw Error("Unmounted component");
        }
    }

    componentDidMount() {
        this.mounted = true;
        var docsToSign = JSON.parse(sessionStorage.getItem('docsToSign'));
     //   console.log("DOCS TO SIGN", docsToSign);
        if(docsToSign) {
            // mark docs as selected again after redirect
            this.setState({selected: docsToSign});
            this.setState({signerAuthReady:true});
        }

        fetch(constants.SERVER_URL + "/api/profile",{method:'get'})
        .then(resp => this.checkFetchRespSession(resp))
        .then(resp => resp.json())
        .then(data => {
            fetch(constants.SERVER_URL+"/api/mypendingdocs",{method:'get'})
            .then(resp => this.checkMounted(resp))
            .then(resp => this.checkFetchRespSession(resp))
            .then(resp =>resp.json())
            .then(resp => {
                console.log("RESPONSE:", resp)
                return resp;
            })
            .then(resp => this.combineSignedCounts(resp))
            .then(resp => this.combineStatusAndTimestamp(resp))
            .then(resp => this.setCanSign(resp,data.email))
            .then(resp =>this.setState({myPendingDocs:resp}))
            .then(resp => this.setState({myEmailAddress:data.email}))

            .catch(error => console.log("Fetching mypendingdocs error:", error));
        })
        .catch(error => console.log("Fetching profile error:", error));
 
        fetch(constants.SERVER_URL+"/api/pendingdocs",{method:'get'})
        .then(resp => this.checkMounted(resp))        
        .then(resp => this.checkFetchRespSession(resp))
        .then(resp =>resp.json())
        .then(resp => this.combineSignedCounts(resp))
        .then(resp => this.combineStatusAndTimestamp(resp))
        .then(data =>this.setState({pendingDocs:data}))
        .catch(error => console.log("Fetching pendingDocs error:", error));
    }

    componentWillUnmount(){
        this.mounted = false;
      }

    componentDidUpdate () {
        if(this.mounted === true) {
            this.checkPendingSignReqs();
        }
    }

    rowStyleFormat = (row, rowIdx) => {
        if(this.state.myPendingDocs[rowIdx].signFailed === true) {
            return { backgroundColor: 'red' };
 
        } else{
            return ;
        }
      }    
    selectedRowStyleFormat = (row, rowIdx) => {
        if(this.state.myPendingDocs[rowIdx].signFailed === true) {
            return { backgroundColor: 'red' }; 
 
        } else{
            return { backgroundColor: '#00BFFF' };
        }
      }

    dismissAlert = () => {
        this.setState({showAlert:false});
        // clear failed docs 
        this.setState({myPendingDocs:this.state.myPendingDocs.map(item => {
            item.signFailed = false;
            return item;
        })})
    }

    AlertError = (props) => {
        const { t } = this.props
        if (this.state.showAlert) {
            window.scrollTo(0,0);
            return (
                <div>
                <Alert variant="danger" onClose={this.dismissAlert} dismissible>
                <h4>{t("Operation failed")}</h4>
                <p>
                    {t("Operation not done for all selected documents.")}
                </p>
                </Alert>
                </div>
            );
        }
    }

    showProgressbar = (props) => {
        const { t } = this.props
        if(this.state.operationOngoing === true) {
            return (<div><ProgressBar animated now={100} label={t("Operation ongoing")}/> <br /></div>);
        } else {
            return null;
        }
    }

    modalOnHide = () => {
        this.setState({authenticationURL:null});
        this.setState({operationOngoing:false});
    }

    authMethodModalOnHide = () => {
        this.setState({showAuthMethodModal:false});
        this.setState({operationOngoing:false});
    }
    
    showAuthenticationModal = (props) => {
        const { t } = this.props
        return (
            <Modal show={this.state.authenticationURL !== null} id={"Iframe"} onHide = {this.modalOnHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t("User authentication")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Iframe url={this.state.authenticationURL}
                width="100%"
                height="650px"
                className="myClassname"
                display="initial"
                position="relative"/>
            </Modal.Body>
          </Modal>
        )
    }

    checkSelectedDocsAuthMethod = (authMethods) => {
        var docsToSign = this.getDocsToSign();
        var failedDocs = [];
        var supported;

        var authMethodArray = authMethods.split(','); 
        for(var i=0;i<docsToSign.length;i++) {
            supported = false;
            for(var s=0;s<authMethodArray.length;s++) {
                if(docsToSign[i].authMethods === null || docsToSign[i].authMethods === '' || docsToSign[i].authMethods.includes(authMethodArray[s]) ||
                    (this.suomiAuth && authMethodArray[s] === "AUTH_METHOD_SUOMIFI")) {
                    supported = true;
                    break   
                }
            }
            if(!supported) {
                failedDocs.push(docsToSign[i]);
            }
        }

        if(failedDocs.length) {
            var failMarkedData = this.state.myPendingDocs.map(item => {
                var failedTbl = failedDocs.filter(failedDoc => failedDoc.reqId === item.id)
                if(failedTbl.length === 1) {
                    // this is failed doc
                    item.signFailed = true;
                }
                return item;
            })
            this.setState({myPendingDocs:failMarkedData});
            return false;
        }
        return true;
    }

    onClickAuthMethod = (authMethods) => {
        // check that all docs can be signed with selected autentication method
        if(this.checkSelectedDocsAuthMethod(authMethods)) {
            this.authenticateSigner(authMethods);
            this.setState({showAuthMethodModal:false});
        } else {
            // all documents can not be signed with the selected auth method
            this.setState({showAuthMethodModal:false});
            this.setState({operationOngoing:false});
            this.setState({showAlert:true});
        }

    }

    onClickBankAndMobile = () =>  {
        this.onClickAuthMethod("AUTH_METHOD_BANK,AUTH_METHOD_MOBILE");
    }

    onClickCallSign = () =>  {
        this.onClickAuthMethod("AUTH_METHOD_CALLSIGN");
    }

    onClickSuomiFi = () =>  {
        this.onClickAuthMethod("AUTH_METHOD_SUOMIFI");
    }    

    showAuthenticationMethodModal = (props) =>{
        const { t } = this.props
        var bankAndMobileMethod = null;
        var callSignMethod = null;
        var suomifiSignMethod = null;

        if(this.state.authMethodModalModes.includes("AUTH_METHOD_BANK") || this.state.authMethodModalModes.includes("AUTH_METHOD_MOBILE")) {
            bankAndMobileMethod = <Button  block onClick={this.onClickBankAndMobile}>{t("Mobile or Bank")}</Button>;
        }
        if(this.state.authMethodModalModes.includes("AUTH_METHOD_CALLSIGN")) {
            callSignMethod = <Button block onClick={this.onClickCallSign}>CallSign</Button>;
        }

        if(this.state.authMethodModalModes.includes("AUTH_METHOD_SUOMIFI")) {
            suomifiSignMethod = <Button block onClick={this.onClickSuomiFi}>Suomi.fi</Button>;
        }

        return (
            <Modal size="sm" show={this.state.showAuthMethodModal} id={"authMethodModal"} onHide = {this.authMethodModalOnHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t("User authentication")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-grid gap-2">
                {bankAndMobileMethod}
                {callSignMethod}
                {suomifiSignMethod}
                <br/>
                <Button  className="float-right" onClick={this.authMethodModalOnHide}>{t("Cancel")}</Button>
            </Modal.Body>
          </Modal>
        ) 
    }

    RejectConfirmModalOnHide = () => {
        this.setState({showRejectConfirmModal:false});
    }    

    showRejectConfirmModal = (props) =>{
        const { t } = this.props
        return (
            <Modal size="sm" show={this.state.showRejectConfirmModal} id={"RejectConfirmModal"} onHide = {this.RejectConfirmModalOnHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Are You sure")}</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant="primary" onClick={this.rejectSelectedDocuments}>{t("Yes")}</Button>
                <Button variant="secondary" onClick={this.RejectConfirmModalOnHide}>{t("Cancel")}</Button>
            </Modal.Footer>
          </Modal>
        ) 
    }

    showWaitModal = (props) => {
        const { t } = this.props

        if(this.state.signOngoingIndex !== -1) {
            var progressbarText = this.state.signOngoingIndex+ "/" +this.state.selected.length +" ("+this.signDocumentOngoingIndex+")";
            console.log("Allekirjoitus menossa: ", progressbarText)
            return (
                <Modal size="sm" show={this.state.operationOngoing === true} id={"IframeWait"} onHide = {() =>{}}>
                <Modal.Header>
                    <Modal.Title>{t("Operation ongoing")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div><ProgressBar animated now={100} label={progressbarText}/> <br /></div>
                </Modal.Body>
              </Modal>
            )
        } else {
            return (
                <Modal size="sm" show={this.state.operationOngoing === true} id={"IframeWait"} onHide = {() =>{}}>
                <Modal.Header>
                    <Modal.Title>{t("Operation ongoing")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div><ProgressBar animated now={100} label={t("Operation ongoing")}/> <br /></div>
                </Modal.Body>
              </Modal>
            )
        }
    }


    renderMySignRequests(props) {
        const { t } = this.props
        return (
            <div>
            {this.AlertError()}
            <BootstrapTable 
                keyField='id' 
                data={ this.state.myPendingDocs.map(item => {
                    item.formattedSignStatus = this.createSignedCountsText(item.signStatus);
                    return item;
                }) } 
                columns={[
                        { dataField: 'docName',     text: t("Document Name")},
                        { dataField: 'reqDate',     text: t("Request Created"), formatter: dt => (<div>{this.renderDateTime(dt)}</div>)},
                        { dataField: 'requestor',   text: t("Requested By")},
                        { dataField: 'formattedSignStatus',  text: t("Status")},
                        { dataField: 'dueDate',     text: t("Due Date"), formatter: dt => (dt === null?null:<div>{this.renderDate(dt)}</div>)}
                    ]} 
                rowStyle={this.rowStyleFormat}
                selectRow={
                    {
                    mode: 'checkbox',
                    clickToExpand: true, 
                    clickToSelect: false, 
                    style: this.selectedRowStyleFormat,
                    selected: this.state.selected,
                    onSelect: this.handleOnSelect,
                    onSelectAll: this.handleOnSelectAll,
                    nonSelectable: this.state.myPendingDocs.filter(item => item.canSign === false).map(item => item.id),
                    nonSelectableStyle: () => {return {backgroundColor:'lightgrey'}}
                    }
                 } 
                expandRow={{
                        renderer: row => (
                            <div className="container-fluid">
                                <div className="NotAllowedYet" >{!row.canSign?t("Handling not allowed yet"):null}</div>
                                <Table className="table-sm">
                                <tbody className="expandTblRow"> 
                                    <tr valign="top"><td></td>
                                        <td valign="top"><Table><tbody>
                                            <tr><td><b>{t("File Name")}: </b></td><td><img src={pdficon} alt="Fujitsu" height="20"></img><a href = {this.getDocument(row.origDocId)} download={row.fileName} target="_blank" rel="noopener noreferrer">{row.fileName} </a></td></tr>
                                            <tr><td><b>{t("Requested By")}: </b></td><td>{row.requestor}</td></tr>
                                            <tr><td><b>{t("Due Date")}: </b></td><td>{this.renderDate(row.dueDate)}</td></tr>
                                        </tbody>    
                                        </Table></td>
                                        <td></td>
                                        <td><Table className="table-sm">
                                            <thead>
                                                <tr><th style={{width: "50%"}}>{t("Signatures")}:</th><th style={{width: "50%"}}>{t("Status")}:</th></tr>
                                            </thead>
                                            <tbody>
                                            {this.renderSigners(row.signers)}
                                            </tbody>
                                        </Table></td>
                                    </tr>
                                    {row.attachments && row.attachments.length > 0? 
                                        <tr><td></td>
                                        <td>
                                            <Table className="table-sm">
                                                <tbody>
                                                <tr>
                                                <td style={{width: "27%"}}><b>{t("Attachments")}</b></td>
                                                <td>
                                                    {this.renderAttachments(row.attachments)}
                                                </td>
                                                
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>:null}
                                </tbody>    
                                </Table>
                            </div>
                        ), showExpandColumn: true,
                        expandColumnRenderer: ({ expanded }) => {
                            if (expanded) {
                            return (
                                <b>{'\u25bc'}</b>
                            );
                            }
                            return (
                            <b>{'\u25ba'}</b>
                            );
                        },
                        expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                            if (isAnyExpands) {
                              return <b>{'\u25bc'}</b>;
                            }
                            return <b>{'\u25ba'}</b>;
                          }
                    }} 
                hover 
                striped 
            />
            {this.showProgressbar()}
            <Button onClick = {this.startSignProcess}>{t("Sign Selected Documents")}</Button> {'   '} <Button onClick={this.startRejectProcess}>{t("Reject Selected Documents")}</Button>
            </div>
        )
    }

    renderOtherRequests(props) {
        const { t } = this.props
        return (
            <div>
                <BootstrapTable keyField='id'
                data={ this.state.pendingDocs.map(item => {
                    item.formattedSignStatus = this.createSignedCountsText(item.signStatus);
                    return item;
                }) }
                columns={[
                    { dataField: 'docName',     text: t("Document Name")},
                    { dataField: 'reqDate',     text: t("Request Created"), formatter: dt => (<div>{this.renderDateTime(dt)}</div>)},
                    { dataField: 'requestor',   text: t("Requested By")},
                    { dataField: 'formattedSignStatus',  text: t("Status")},
                    { dataField: 'dueDate',     text: t("Due Date"), formatter: dt => (dt === null?null:<div>{this.renderDate(dt)}</div>)}
                ]}
                expandRow={{
                    renderer: row => (
                        <div className="container-fluid">
                            <Table className="table-sm">
                            <tbody className="expandTblRow"> 
                                <tr valign="top"><td></td>
                                    <td valign="top"><Table><tbody>
                                        <tr><td><b>{t("File Name")}: </b></td><td><img src={pdficon} alt="Fujitsu" height="20"></img><a href = {this.getDocument(row.origDocId)} download={row.fileName} target="_blank" rel="noopener noreferrer">{row.fileName} </a></td></tr>
                                        <tr><td><b>{t("Requested By")}: </b></td><td>{row.requestor}</td></tr>
                                        <tr><td><b>{t("Due Date")}: </b></td><td>{this.renderDate(row.dueDate)}</td></tr>
                                    </tbody>    
                                    </Table></td>
                                    <td></td>
                                    <td><Table className="table-sm">
                                        <thead>
                                        <tr><th style={{width: "50%"}}>{t("Signatures")}:</th><th style={{width: "50%"}}>{t("Status")}:</th></tr>
                                        </thead>
                                        <tbody>
                                        {this.renderSigners(row.signers)}
                                        </tbody>
                                    </Table></td>
                                </tr>
                                {row.attachments && row.attachments.length > 0? 
                                        <tr><td></td>
                                        <td>
                                            <Table className="table-sm">
                                                <tbody>
                                                <tr>
                                                <td style={{width: "27%"}}><b>{t("Attachments")}</b></td>
                                                <td>
                                                    {this.renderAttachments(row.attachments)}
                                                </td>
                                                
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>:null}                                
                            </tbody>    
                            </Table>
                        </div>
                    ), showExpandColumn: true,
                    expandColumnRenderer: ({ expanded }) => {
                        if (expanded) {
                        return (
                            <b>{'\u25bc'}</b>
                        );
                        }
                        return (
                        <b>{'\u25ba'}</b>
                        );
                    },
                    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                        if (isAnyExpands) {
                          return <b>{'\u25bc'}</b>;
                        }
                        return <b>{'\u25ba'}</b>;
                      }
                }}
                hover striped />      
            </div>
        )
    }

    renderNoDocuments(props) {
        const { t } = this.props
        return (
            <div>
                <p>{t("No documents waiting for signatures")}</p>
            </div>
        )
    }

    checkPendingSignReqs () {
        if(this.state.signerAuthReady && this.state.myPendingDocs.length) {
            var docsToSign = JSON.parse(sessionStorage.getItem('docsToSign'));
         //   console.log("checkPendingSignReqs docsToSign", docsToSign);
            this.setState({signerAuthReady:false});

            if(docsToSign) {
                // sign selected docs
                sessionStorage.removeItem('docsToSign');
                this.signSelectedDocuments();
            }
        }
    }
  render() {
      const { t } = this.props
      let myPending
      if (this.state.myPendingDocs.length > 0) {
          myPending = this.renderMySignRequests();
      } else {
          myPending = this.renderNoDocuments();
      }
      let autenticationModal
      if(this.state.authenticationURL != null) {
        autenticationModal = this.showAuthenticationModal();
      }
      let showWaitModal;
      if(this.state.operationOngoing) {
        showWaitModal = this.showWaitModal();
      }

      let otherPending
      if (this.state.pendingDocs.length > 0) {
          otherPending = this.renderOtherRequests();
      } else {
          otherPending = this.renderNoDocuments();
      }
      let autenticationMethodModal;
      if(this.state.showAuthMethodModal)  {
        autenticationMethodModal = this.showAuthenticationMethodModal()
      }
      let rejectionConfirmModal;
      if(this.state.showRejectConfirmModal)  {
        rejectionConfirmModal = this.showRejectConfirmModal()
      }      

      return (
      <div>
        <Customize.Style />
        <p><br></br> </p>
        <h1 id='title'>{t("Signature Requests")}</h1>
        <p></p>
        <h3>{t("Documents to be signed by you")}</h3>
            {myPending}
            {autenticationModal}
            {showWaitModal}
            {autenticationMethodModal}
            {rejectionConfirmModal}
        <p><br/></p>
        <h3>{t("Documents waiting for other signatures")}</h3>
            {otherPending}
      </div>
    );
  }
}

export default withTranslation()(Pending);




